import script from "./BaseSearchInput.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseSearchInput.vue?vue&type=script&setup=true&lang=js"

import "./BaseSearchInput.vue?vue&type=style&index=0&id=e94992dc&lang=scss&scoped=true"

import exportComponent from "/Users/river/dev/packages/plugin-openkaarten-frontend-plugin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e94992dc"]])

export default __exports__